import { render, staticRenderFns } from "./VideoRoomControls.vue?vue&type=template&id=f217e062&scoped=true"
import script from "./VideoRoomControls.vue?vue&type=script&lang=js"
export * from "./VideoRoomControls.vue?vue&type=script&lang=js"
import style0 from "./VideoRoomControls.vue?vue&type=style&index=0&id=f217e062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f217e062",
  null
  
)

export default component.exports